export default __webpack_public_path__ + "static/media/8Vid.93668fc2.mp4";